// extracted by mini-css-extract-plugin
export default {"sortWrap":"DragableProvider_sortWrap__XMFO8","sortIdentBody":"DragableProvider_sortIdentBody__wN0SD"};